import gsap from 'gsap';

export default function initTextMedia() {
  gsap.to('.badge', {
    keyframes: [
      { y: 0, duration: 0.4, ease: 'power2.in' },      // fall
      { y: -14, duration: 0.5, ease: 'power2.out' },    // first bounce
      { y: 0, duration: 0.4, ease: 'power2.in' },       // land
      { y: -8, duration: 0.35, ease: 'power2.out' },    // second bounce
      { y: 0, duration: 0.3, ease: 'power2.in' },       // settle
    ],
    repeat: -1,
  });
}
